import * as constants from '../constants';

const INITIAL_STATE = {
    item: undefined,
    loading: false,
    error: null,
};

export default function(state = INITIAL_STATE, action) {
    switch (action.type) {
        case constants.AUTH_LOGOUT:
        case constants.AUTH_LOGIN_SUCCESS:
            return INITIAL_STATE;

        case constants.SURVEY_REQUESTED:
            return Object.assign({}, state, {loading: true, error: null});
        case constants.SURVEY_EDIT_REQUESTED:
            return Object.assign({}, state, {loading: true, error: null});
        case constants.SURVEY_UNLOAD:
            return Object.assign({}, state, {loading: false, item: undefined, error: null});
        case constants.SURVEY_CREATE_REQUESTED:
            return Object.assign({}, state, {loading: true, error: null});
        case constants.SURVEY_SUCCESS:
        case constants.SURVEY_WAVE_CREATE_SUCCESS:
        case constants.SURVEY_WAVE_EDIT_SUCCESS:
            return Object.assign({}, state, {loading: false, item: action.payload.data, error: null});
        case constants.SURVEY_WAVE_DELETE_SUCCESS:
            return Object.assign({}, state, {loading: false, item: Object.assign({}, state.item, {waves: action.payload.data}), error: null});
        case constants.SURVEY_FAILURE:
            return Object.assign({}, state, {loading: false, item: null, error: action.payload.error});
    }
    return state;
}
